//cctv - project prefix
enum CctvMethods {
  CAMERA_INDEX = 'cctv.camera.index',
  STREAM_INDEX = 'cctv.stream.index',
  STREAM_DELETE = 'cctv.stream.delete',
}

export default CctvMethods;
